import type { IMenuSection } from '@fondationcss/ui';

/**
 * Whether the sidebar shows a section to this user, by the Fondation's own rule for a section
 * (useMenuAcl): one of its permissions, and its feature flag ON. The flag is read strictly — a flag
 * the catalog does not know hides the section, as the Fondation hides it. Pure, so the section
 * clamp (use-menu-section-guard) is tested without mounting the sidebar.
 */
export function sectionShows(
  section: Pick<IMenuSection, 'permissions' | 'feature'>,
  permissions: readonly string[],
  flags: Readonly<Record<string, boolean>>,
): boolean {
  if (section.permissions && !section.permissions.some(p => permissions.includes(p))) return false;
  if (section.feature && flags[section.feature] !== true) return false;
  return true;
}
